/**
 * Company codes (companyID) no company may take.
 *
 * ORPHAN is the sentinel owner of orphan orders created from carrier invoices
 * (functions/src/ap/orphanCascade.js ORPHAN_COMPANY_ID, SX-0009). A company
 * with that code would let its users read every orphan, so it is reserved.
 */
export const ORPHAN_COMPANY_ID = 'ORPHAN';

const RESERVED = new Set([ORPHAN_COMPANY_ID]);

/** True when `companyID` is reserved (case- and whitespace-insensitive). */
export const isReservedCompanyId = (companyID) =>
    RESERVED.has(String(companyID || '').trim().toUpperCase());

export const reservedCompanyIdMessage = (companyID) =>
    `Company ID "${String(companyID || '').trim()}" is reserved by the system. Please choose a different Company ID.`;
